import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class TransfersModel extends BaseAPIModel {
    static list(item) {
        return this.fromJSON(item);
    }

    static getDownloadUrl({ organizationId, transferId }) {
        return `/ticket/organizations/${organizationId}/accountancy/transfers/${transferId}/download_url`;
    }

    getUrl({ organizationId, transferId }) {
        if (!organizationId || !transferId) {
            throw new ArgumentError(`[Model][Transfers][get] organizationId and transferId are mandatory`);
        }
        const url = this.constructor.getDownloadUrl({ organizationId, transferId });
        return fetcher.get(url).then(({ response }) => {
            this.data_url = response;
            return this;
        });
    }

    static getStateUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Transfers][getStats] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/transfers/stats`;
    }

    static getState({ organizationId }) {
        return fetcher.get(this.constructor.getStateUrl({ organizationId }));
    }

    static getInfo({ organizationId }, url) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Transfers][getInfo] organizationId is mandatory`);
        }

        return fetcher.get(`/ticket/organizations/${organizationId}/accountancy/transfers`, { query: url });
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Transfers][list] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/transfers`;
    }
}

export class TransfersStateModel extends TransfersModel {
    static listUrl({ organizationId }) {
        return this.getStateUrl({ organizationId });
    }
}
